import React from 'react';

import WelcomeScreen from './components/WelcomeScreen';
import type { OnboardingStepProps } from './onboardingTypes';

const OnboardingStep1_Welcome: React.FC<OnboardingStepProps> = (props) => {
  return <WelcomeScreen />;
};

export default React.memo(OnboardingStep1_Welcome);
